module.exports = __webpack_public_path__ + "img/banner13-4@2x.ead6ce98.jpg";